export default "__VITE_ASSET__eae5782d__"